import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../infrastructure/api.service';
import { QuickStartDto } from './dto/quick-start.dto';

@Injectable({ providedIn: 'root' })
export class QuickStartHttpService extends ApiService {
  get(): Observable<QuickStartDto> {
    return this.httpClient.get<QuickStartDto>(`${this.env.apiUrl}/me/quick-start`);
  }
}
